import { OsUpdate } from '@era/osupdates-sdk';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

export type AvailableOsUpdatesState = EntityState<OsUpdate>;

export function selectId(availableOsUpdate: OsUpdate) {
  return availableOsUpdate.productKey;
}

export const adapter: EntityAdapter<OsUpdate> = createEntityAdapter<OsUpdate>({
  selectId,
});

export const initialState: AvailableOsUpdatesState = adapter.getInitialState();
